module.exports = __webpack_public_path__ + "static/img/img-yamaha-mx-king.5931b81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-yamaha-mx-king.png
// module id = GOzq
// module chunks = 36